import { render, staticRenderFns } from "./PolicyEndorsementCoverage.vue?vue&type=template&id=d40f8f68"
import script from "./PolicyEndorsementCoverage.vue?vue&type=script&lang=ts"
export * from "./PolicyEndorsementCoverage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports